





























































import { Vue, Component, Prop } from 'vue-property-decorator';
import ArrowDownIcon from '../components/icons/ArrowDownIcon.vue';
import InfoTooltip from '@/components/common/InfoTooltip.vue';
import ArrowLeftIcon from '../components/icons/ArrowLeftIcon.vue';
import NavBar from '../components/common/NavBar.vue';
import { PhaseKeys, PhaseLabels } from '@/models/phase';
import { TypeKeys, TypeLabels } from '@/models/types';

@Component({
  components: {
    ArrowDownIcon,
    ArrowLeftIcon,
    InfoTooltip,
    NavBar
  }
})
export default class Home extends Vue {
  phasesLevels = [
    { route: PhaseKeys.IDEA, label: PhaseLabels.IDEA },
    { route: PhaseKeys.PREANALYSIS, label: PhaseLabels.PREANALYSIS },
    { route: PhaseKeys.SPECIFICATION, label: PhaseLabels.SPECIFICATION },
    { route: PhaseKeys.DEVELOPMENT, label: PhaseLabels.DEVELOPMENT },
    { route: PhaseKeys.IMPLEMENTATION, label: PhaseLabels.IMPLEMENTATION },
    { route: PhaseKeys.OPERATION, label: PhaseLabels.OPERATION },
    { route: PhaseKeys.DECOMMISSIONED, label: PhaseLabels.DECOMMISSIONED }
  ];

  typeLevels = [
    { route: TypeKeys.PARENT, label: TypeLabels.PARENT },
    { route: TypeKeys.GLOBAL_PARENT, label: TypeLabels.GLOBAL_PARENT }
  ];
}
